__turbopack_context__.v({
  "active": "switcher-item-module__lmgd7W__active",
  "activeDot": "switcher-item-module__lmgd7W__activeDot",
  "item": "switcher-item-module__lmgd7W__item",
  "link": "switcher-item-module__lmgd7W__link",
});
